<template>
  <div>
    <div class="row" style="padding-bottom:10px">
      <div class="col-md-12">
        <h3>Selecione um colaborador:</h3>
        <v-select
        :options=users
        label="name"
        v-model="selectedUser"
        style="width:30%"
        >
      </v-select>
      <button v-if="selectedUser" type="button" class="btn pull-right" @click="extract" style="margin-top:-35px; font-weight:bold;background-color:#4cbb17; color:white">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>Extrair dados
        </button>
      </div>
    </div>

    <base-crud
      v-if="selectedUser"
      crudName="Presenças"
      newText="Nova Presença"
      :table="attendanceTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="false"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :key="key"
      :extra="extra"
      @modalImage="modalImage"
    ></base-crud>
        <!-- Modal Assinatura-->
        <div
      class="modal fade"
      id="signModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="signModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signModalLabel">
              Captura da Assinatura
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img :src="this.image_signature" width="100%" />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function() {
    return {
      image_signature: '',
      key: 0,
      selectedUser: '',
      themes: [],
      users: [],
      attendanceTable: "attendanceTable",
      pages: [],
      url: "",
      columns: ["event_id","id",  "title", "started_at", "closed_at", "event_time", "status", "type", "actions"],
      tableData: ["event_id","id", "title", "started_at", "closed_at", "event_time", "status", "type"],
      options: {
        filterable:["event_id", "id"],
        filterByColumn: true,                   
        sortable: ["id", "status", "type"],
        templates: {
          event_id: (h, row, index) => {
            if(row.event){
              return row.event.id
            }
            return '';
          },
          title: (h, row, index) => {
            if(row.event){
              return row.event.theme.title
            }
            return '';
          },
          dds_date: (h, row, index) => {
            if(row.event){
              return new Date(row.event.dds_date).toLocaleDateString();
            }
            return '';
          },
          started_at: (h, row, index) => {
            if(row.event){
              return new Date(row.event.started_at).toLocaleString();
            }
            return '';
          },
          closed_at: (h, row, index) => {
            if(row.event){
              return new Date(row.event.closed_at).toLocaleString();
            }
            return '';
          },
          event_time: (h, row, index) => {
            return row.event.duration;
          },
          status: function (h, row, index) {
            return row.statusName
          },
          type: function (h, row, index) {
            return row.signatureType
          },
        },
        pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
        perPage: 100,
        perPageValues: [100],
        headings: {
          id: "ID Assinatura",
          event_id: "ID Evento",
          title: "Tema",
          started_at: "Início em",
          closed_at: "Encerrado em",
          event_time: "Tempo de Evento",
          dds_date: "Data",
          status: "Status",
          type: "Tipo de Assinatura",
          actions: "Visualizar Assinatura"
        },
        requestFunction: function(data) {
          let requestData = {};

           let query = this.$parent.$parent.query(data.query);
           requestData.params = data;
           requestData.params.query = "";
           requestData.params.with = ['event', 'event.theme'];

          return this.$http
              .get(this.url + '?' + query, requestData)
              .catch(
                  function(e) {
                      this.dispatch("error", e);
                  }.bind(this)
              );
        }
      },
      extra:[
        {
          id: 1,
          label: "",
          class: "btn btn-info fa fa-eye",
          style: "",
          title: "Visualizar Assinatura",
          name: "modalImage",
          icon: ""
        },
      ],
      endPoint: "events_signatures/"
    };
  },
  watch: {
    selectedUser(){
      this.key++;  
    }
  },
  methods: {
    msToTime(duration) {
    var milliseconds = Math.floor((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
    },
    modalImage(props) {
      this.image_signature = props.row.signature_image;
      $("#signModal").modal({
        show: true,
      });
    },
    extract(){
      const self = this;
      const api = self.$store.state.api + self.endPoint + 'extract/' + this.selectedUser.id ;
      self.$http
          .get(api)
          .then(response => {
              window.open(
                  self.$store.getters.url +
                      "downloadExtractByHash/events_signatures/" +
                      response.data,
                  "_blank"
              );
          })
          .catch(error => {
              self.$message("Erro", error.response.data, "error");
          });
    },
    getThemes() {
      const self = this;
      const api = self.$store.state.api + "themes"

      self.$http
        .get(api)
        .then((response) => {
          self.themes = response.data.data;
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
    },
    getUsers(){
      const self = this;
      const api = self.$store.state.api + "users"

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
    },
    query: function (query) {
      let columns = {
        id: 'id',
        event_id: 'event[id]',
        started_at: 'event[started_at]',
        closed_at: 'event[closed_at]',
        dds_date: 'dds_date',
        status: 'statusName',
        type: 'signature_image'
      };
      let filters = '&user_id=' + this.selectedUser.id + '&paginated=false&';
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  mounted(){
    this.getUsers();
    this.getThemes();
  },
  components: {
    BaseCrud,
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/checkUser/CheckUser.vue